<template>
  <div class="featureTab">
    <fg-input
      type="search"
      :placeholder="$t('button.search')"
      v-model.lazy="filter.text"
      addon-left-icon="fa fa-search"
    ></fg-input>

    <SelectList
      :options="statusOptions"
      value="ALL"
      @select="(val) => (this.filter.status = val)"
    />

    <hr />
    <div id="itemListBase" ref="itemListBase">
      <div id="itemList">
        <template v-for="item in this.deviceList">
          <MapDeviceEntry
            :entry="item"
            :key="item.uniqueId"
            @click="selectedItem"
          ></MapDeviceEntry>
        </template>
      </div>
    </div>
    <div id="paginat" class="pagination" v-if="totalRows > perPage">
    <p class="deviceCounter">(
      {{ totalRows }} )
    </p>
      <b-pagination
        class="map-pagination"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="fill"
        first-number
        last-number
        limit="2"
      >
      </b-pagination>
    </div>

    <transition name="slide">
      <div class="slidein" v-if="item">
        <MapDeviceDetails
          v-if="item"
          :key="this.selectedDeviceId"
          :itemId="this.selectedDeviceId"
          @hideItemDetails="hideItemDetails"
        ></MapDeviceDetails>
      </div>
    </transition>
  </div>
</template>
<style scoped lang="scss">
div.featureTab {
  max-height: 90%;
  display: flex;
  flex-direction: column;

  #itemListBase {
    display: flex;
    flex-flow: column;
    overflow: auto;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: stretch;
    justify-content: flex-start;
    align-items: stretch;
  }
}
#itemList {
  flex-grow: 4;
}

#paginat {
  order: 99;
}
</style>

<script>
import MapDeviceDetails from '@/components/Map/MapDeviceDetails'
import MapDeviceEntry from '@/components/Map/MapDeviceEntry'
import mapstore from '@/store/map/mapstore'

export default {
  name: 'Devices',
  components: {
    MapDeviceEntry,
    MapDeviceDetails,
  },
  props: {},
  data: function () {
    return {
      devList: [],
      dataUpdated: null,
      realtimeUpdate: true,
      dataUpdateIntervalSec: 10,
      realtimeTimerId: null,
      currentPage: 1,
      perPage: 25,
      item: null,
      deepLinkUsed: false,
      filter: {
        text: '',
        status: 'ALL',
      },
      statusOptions: [
        {
          id: 'ALL',
          label: this.$t('filter.no'),
          icon: 'filter',
          caption: this.$t('sse_displays.status'),
        },
        {
          id: 'ONLINE',
          label: this.$t('sse_displays.states.ONLINE'),
          icon: 'check-square-fill',
          variant: 'success',
        },
        {
          id: 'OFFLINE',
          label: this.$t('sse_displays.states.OFFLINE'),
          icon: 'exclamation-square-fill',
          variant: 'danger',
        },
        {
          id: 'UNKNOWN',
          label: this.$t('sse_displays.states.UNKNOWN'),
          icon: 'question-square-fill',
          variant: 'secondary',
        },
      ],
      statusFilter: 'ALL',
    }
  },
  beforeCreate: function () {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule('mapstore', mapstore)
    }
  },
  watch: {
    dataUpdated: function () {
      if (!this.realtimeUpdate) return

      const delay = this.dataUpdateIntervalSec * 1000
      if (this.realtimeTimerId == null)
        this.realtimeTimerId = setTimeout(() => {
          this.realtimeTimerId = null
          this.updateData()
        }, delay)
    },
    devicesForTable: function (newData) {
      this.devList = JSON.parse(JSON.stringify(newData))
      setTimeout(this.tuneListLenght, 200)
    },
  },
  computed: {
    filteredDevices() {
      let devices = this.devList

      if (this.filter.text !== '') {
        devices = devices.filter((device) => {
          const filterText = this.filter.text.toLowerCase()
          return (
            device.uniqueId.toLowerCase().includes(filterText) ||
            device.name.toLowerCase().includes(filterText)
          )
        })
      }

      if (this.filter.status !== 'ALL') {
        devices = devices.filter((device) => {
          return this.filter.status === device.onlineStatus
        })
      }

      return devices
    },
    totalRows() {
      const filteredDevices = this.filteredDevices
      return filteredDevices ? filteredDevices.length : 0
    },
    deviceList() {
      const filteredDevices = this.filteredDevices
      const begin = (this.currentPage - 1) * this.perPage
      const end = begin + this.perPage

      return filteredDevices ? filteredDevices.slice(begin, end) : []
    },
    selectedDeviceId() {
      if (this.item == null) return null

      try {
        if (this.item.device != undefined) {
          return this.item.device.deviceId
        } else {
          return this.item.deviceId
        }
      } catch (err) {
        return null
      }
    },
    devicesForTable() {
      return this.$store.state.mapstore.devicesForTable
    },
  },
  mounted: function () {
    const displayId = this.$route.query.displayId;
    if(displayId) {
      this.filter.text = displayId;
    }
    this.updateData()
    this.$store.dispatch('mapstore/getMapConfig').then((data) => {
      try {
        this.dataUpdateIntervalSec = data.deviceLayer.updateIntervalSeconds
      } catch (err) {
        /*empty*/
      }
    })
    setTimeout(this.tuneListLenght, 200)
  },
  methods: {
    listOverflows: function () {
      try {
        let elem = this.$refs.itemListBase
        let result = elem.scrollHeight > elem.clientHeight
        return result
      } catch (err) {
        return false
      }
    },
    tuneListLenght: function () {
      if (this.listOverflows()) {
        this.listLimit = this.listLimit - 1
        setTimeout(this.tuneListLenght, 100)
      }
    },
    selectedItem(tunnus) {
      this.showItemDetails(tunnus)
      this.$emit('itemSelected', this.item)
    },
    showItemDetails(tunnus) {
      let selected = null
      selected = this.devList.find((i) => {
        try {
          if (i.device != undefined && i.device != null)
            return i.device.deviceId == tunnus
          else return i.deviceId == tunnus
        } catch (err) {
          return false
        }
      })
      this.item = selected
    },
    hideItemDetails() {
      this.item = null
      this.$emit('detailClosed')
    },
    updateData() {
      this.dataUpdated = Date.now()
      this.$store
        .dispatch('mapstore/getDevicesForTable', this.dataUpdateIntervalSec)
        .then(() => {})
        .catch(() => {
          this.dataUpdated = Date.now()
          this.$travellerGetDataError()
        })
    },
  },
}
</script>

<style scoped lang="scss">


.deviceCounter {
  position: relative;
  top: 10px;
  padding-right: 10px;
}

.pagination {
  top: 10px;
  align-items: center;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
}
</style>